<template>
  <div class="py-16 px-4 overflow-hidden">
    <div
      class="relative max-w-xl mx-auto bg-white border-vectric border-4 rounded-t-2xl rounded-br-2xl sm:px-6 lg:px-8 py-16 px-4 shadow "
    >
      <div class="text-center">
        <h2
          class="text-3xl leading-9 font-extrabold font-open-sans tracking-tight text-darkBlue sm:text-3xl sm:leading-10"
        >
          Login
        </h2>
        <p class="mt-4 text-lg leading-6 text-gray-600" v-if="badLink">
          It looks like the link you used may have expired. Please enter your
          email address and we will send you a new invitation.
        </p>
        <div class="mt-4 text-lg leading-6 text-gray-600" v-else>
          Enter your email address and we will send you a link to log in.
          <p class="mt-2 text-md">
            <span class="font-semibold"> Note.</span>
            The email will be sent from noreply@vectric.com. Please check your
            junk email folder if you haven't received your email.
          </p>
        </div>

        <div
          class="mt-4 text-lg leading-6 text-red border border-red p-2"
          v-if="form.validationErrors.length > 0"
        >
          <div v-for="(err, idx) in form.validationErrors" :key="idx">
            {{ err }}
          </div>
        </div>
        <div
          class="mt-4 text-lg leading-6 text-red border border-red p-2"
          v-if="networkErrors.length > 0"
        >
          <div v-for="(err, idx) in networkErrors" :key="idx">
            {{ err }}
          </div>
        </div>
      </div>
      <div v-if="showSpinner === false" class="mt-12">
        <form v-on:submit.prevent="sendLoginLink" method="POST">
          <div>
            <label
              for="email"
              class="block text-sm font-medium leading-5 text-gray-700"
              >Email Address</label
            >
            <div class="mt-1 relative rounded-md shadow-sm">
              <input
                v-model="form.email"
                id="email"
                type="email"
                class="form-input py-3 px-4 block w-full transition ease-in-out duration-150"
              />
            </div>
          </div>
          <div class="mt-6">
            <span class="w-full inline-flex rounded-md shadow">
              <button
                type="submit"
                class="w-full inline-flex items-center justify-center px-6 py-3 border border-transparent leading-6 rounded-md
                raleway-btn bg-vectric text-darkBlue font-semibold
                   transition ease-in-out duration-150 hover:bg-darkBlue hover:text-white focus:outline-none"
              >
                Send Link
              </button>
            </span>
          </div>
        </form>
      </div>
      <div v-if="showSpinner" class="mt-12">
        <submission-spinner />
      </div>
    </div>
  </div>
</template>

<script>
import { sendLoginLink } from "../utils/functions";
import SubmissionSpinner from "../components/SubmissionSpinner";
const siteKey = process.env.VUE_APP_RECAPTCHA_SITE_KEY;

export default {
  name: "EmailLoginForm",
  components: {
    SubmissionSpinner
  },
  props: {
    badLink: {
      type: Boolean,
      required: true,
      default: false
    }
  },
  data() {
    return {
      networkErrors: [],
      form: {
        validationErrors: [],
        email: ""
      },
      showSpinner: false
    };
  },
  methods: {
    sendLoginLink() {
      const vm = this;
      this.form.validationErrors = [];
      this.networkErrors = [];
      if (this.form.email.length < 3) {
        this.form.validationErrors.push("Please enter a valid email address");
        return;
      }
      vm.showSpinner = true;
      window.grecaptcha.ready(function() {
        window.grecaptcha
          .execute(siteKey, {
            action: "submit"
          })
          .then(function(token) {
            sendLoginLink(vm.form.email, token)
              .then(() => {
                window.localStorage.setItem("emailForSignIn", vm.form.email);
                vm.$store.dispatch(
                  "setFlashMessage",
                  "We've sent you an email link it should arrive shortly."
                );
                // redirect
                vm.$router.push("Home");
              })
              .catch(err => {
                vm.networkErrors.push(err);
                vm.showSpinner = false;
              });
          });
      });
    }
  }
};
</script>

<style scoped></style>
